var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5833 2.33268H16.5V0.166016H14.3333V2.33268H5.66667V0.166016H3.5V2.33268H2.41667C1.21417 2.33268 0.260833 3.30768 0.260833 4.49935L0.25 19.666C0.25 20.8577 1.21417 21.8327 2.41667 21.8327H17.5833C18.775 21.8327 19.75 20.8577 19.75 19.666V4.49935C19.75 3.30768 18.775 2.33268 17.5833 2.33268ZM17.5833 19.666H2.41667V7.74935H17.5833V19.666ZM4.58333 9.91602H10V15.3327H4.58333V9.91602Z",
    fill: "#969FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cf2579df1d8df1a1289cb0e920c91386.svg";
export { ForwardRef as ReactComponent };